/**
 * Shared modal entrance: a quick fade (handled by MUI's `Fade` transition, which
 * also drives the correct open/close lifecycle) plus a subtle ~20px drop-in on
 * the dialog paper. Respects `prefers-reduced-motion`.
 */
export const MODAL_TRANSITION_TIMEOUT = 200;

export const modalDropInSx = {
  '@keyframes modalDropIn': {
    from: { transform: 'translateY(-20px)' },
    to: { transform: 'translateY(0)' },
  },
  animation: 'modalDropIn 0.2s ease-out both',
  '@media (prefers-reduced-motion: reduce)': {
    animation: 'none',
  },
};
